import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '../../stores/authStore';
import { client } from '../client';
import { QueryKeys } from '../query-keys';

import type { Invoice } from '../../types/Invoice';

export const getInvoices = async () => {
  const res = await client.get<{ result: Invoice[] }>('/v2/invoices');

  return res.data.result.map((invoice) => {
    // Remove the part after the timezone offset (e.g., [UTC])
    const trimmedIssuedAt = invoice.issuedAt.replace(/\[.*\]$/, '');
    return {
      ...invoice,
      issuedAtDate: new Date(trimmedIssuedAt),
    };
  });
};

export const useInvoices = () => {
  const hasAccessToken = useAuthStore((state) => Boolean(state.accessToken));
  return useQuery({
    queryKey: QueryKeys.Invoices,
    queryFn: getInvoices,
    enabled: hasAccessToken,
  });
};
